import { isRecord } from 'src/utils/common_utils';
import { clearProxySessionMarkers } from 'src/utils/proxySession';

export const WORKSPACE_DELETED_CODE = 'workspace_deleted';

// Same key StorageUtils uses for the persisted redux snapshot.
export const APP_STATE_STORAGE_KEY = 'h38v29jajj9dje2bx';

function isWorkspaceDeletedPayload(data: unknown): boolean {
  return isRecord(data) && data.code === WORKSPACE_DELETED_CODE;
}

export function isWorkspaceDeletedError(error: unknown): boolean {
  if (!isRecord(error)) {
    return false;
  }
  const { response } = error;
  if (isRecord(response) && isWorkspaceDeletedPayload(response.data)) {
    return true;
  }
  return isWorkspaceDeletedPayload(error.data);
}

// leaveDeletedWorkspace drops cached app state and ends every portal session.
// A deleted workspace must not leave the browser sitting on stale data, and
// the person can sign in again to another workspace.
export function leaveDeletedWorkspace(): void {
  if (process.env.JEST_WORKER_ID || typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(APP_STATE_STORAGE_KEY);
  } catch {
    // Private mode can throw. Sign-out still has to run.
  }
  document.cookie = `${APP_STATE_STORAGE_KEY}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  clearProxySessionMarkers();
  window.location.assign('/auth/signout-all');
}
